module.exports = __webpack_public_path__ + "img/Pot1.3a29d613.svg";